export const en = {
    yes: "Yes",
    no: "No",
    newVersion: "There is a new version available for this application. Reload?",
    upgrade: "New version available",
    termsLink: "https://www.kopjra.com/terms_en.html",
    privacyLink: "https://www.kopjra.com/privacy_en.html",
    codDest: "Recipient Code M5UXCR1",
    piva: "VAT 03904120247",
};
